exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cashback[data-v-d3fbb2ba]{margin:0 -15px 15px;padding:0 20px 10px;border-bottom:1px dashed #1e824c}.cashback .cashback-title[data-v-d3fbb2ba]{color:#1e824c;font-weight:900;display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:flex;vertical-align:middle;-webkit-column-gap:5px;-moz-column-gap:5px;column-gap:5px;padding-right:40px}.cashback .cashback-title svg[data-v-d3fbb2ba]{position:absolute;right:12px}.cashback .cashback-message[data-v-d3fbb2ba]{padding-right:40px;color:#000}.cashback .cashback-message .no-points[data-v-d3fbb2ba]{color:#ea4725;font-size:12px}", ""]);

// exports
